import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DeleteConfirmModal } from '../../components/generic/DeleteConfirmModal';
import { createModal } from '../../components/generic/Modal';
import { useDeleteParticipantMutation } from '../../graphql/hooks/useDeleteParticipantMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
  participantName: string;
}

export const ParticipantDeleteModal = createModal<Props>((props) => {
  const { participantId, participantName, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const navigate = useNavigate();
  const mutation = useDeleteParticipantMutation();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
      })
      .then(() => {
        successToast('Participant deleted successfully');
        void navigate(`/organizations/${organization.id}/participants`);
      })
      .catch((err) => {
        errorToast(`Error deleting participant: ${err.message}`);
      });
  }, [organization.id, mutation, participantId, successToast, errorToast, navigate]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this participant?'
      description={
        <ChakraV3.Stack gap={4}>
          <ChakraV3.AlertBanner size='sm' status='info' border='none' alignItems='center'>
            If you want to keep the data, consider archiving the participant instead.
          </ChakraV3.AlertBanner>
        </ChakraV3.Stack>
      }
      confirmation={{
        level: 'Level3',
        confirm: participantName,
        acknowledgement:
          'I understand that this participant and all of their associated data will be permanently deleted.',
      }}
      isLoading={mutation.isLoading}
      onDelete={onDelete}
    />
  );
});
